/**
 * Timezone options for the promise-date / cut-off widget. Kept in sync with the
 * backend allowlist (config/promise_date.php). Stored values are IANA identifiers;
 * the labels show the standard (winter) UTC offset for orientation.
 */
export const TIMEZONE_OPTIONS: { value: string; label: string }[] = [
  { value: 'Europe/Warsaw', label: 'UTC+1 (Warsaw)' },
  { value: 'Europe/Berlin', label: 'UTC+1 (Berlin)' },
  { value: 'Europe/Paris', label: 'UTC+1 (Paris)' },
  { value: 'Europe/Amsterdam', label: 'UTC+1 (Amsterdam)' },
  { value: 'Europe/Brussels', label: 'UTC+1 (Brussels)' },
  { value: 'Europe/Luxembourg', label: 'UTC+1 (Luxembourg)' },
  { value: 'Europe/Madrid', label: 'UTC+1 (Madrid)' },
  { value: 'Europe/Lisbon', label: 'UTC+0 (Lisbon)' },
  { value: 'Europe/Rome', label: 'UTC+1 (Rome)' },
  { value: 'Europe/Vienna', label: 'UTC+1 (Vienna)' },
  { value: 'Europe/Zurich', label: 'UTC+1 (Zurich)' },
  { value: 'Europe/Prague', label: 'UTC+1 (Prague)' },
  { value: 'Europe/Budapest', label: 'UTC+1 (Budapest)' },
  { value: 'Europe/Bucharest', label: 'UTC+2 (Bucharest)' },
  { value: 'Europe/Athens', label: 'UTC+2 (Athens)' },
  { value: 'Europe/Dublin', label: 'UTC+0 (Dublin)' },
  { value: 'Europe/London', label: 'UTC+0 (London)' },
  { value: 'Europe/Stockholm', label: 'UTC+1 (Stockholm)' },
  { value: 'Europe/Copenhagen', label: 'UTC+1 (Copenhagen)' },
  { value: 'Europe/Helsinki', label: 'UTC+2 (Helsinki)' },
];

/** Country → default timezone (mirrors config/promise_date.php `country_timezones`). */
export const COUNTRY_TIMEZONES: Record<string, string> = {
  PL: 'Europe/Warsaw',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  NL: 'Europe/Amsterdam',
  BE: 'Europe/Brussels',
  LU: 'Europe/Luxembourg',
  ES: 'Europe/Madrid',
  PT: 'Europe/Lisbon',
  IT: 'Europe/Rome',
  AT: 'Europe/Vienna',
  CH: 'Europe/Zurich',
  CZ: 'Europe/Prague',
  HU: 'Europe/Budapest',
  RO: 'Europe/Bucharest',
  GR: 'Europe/Athens',
  IE: 'Europe/Dublin',
  GB: 'Europe/London',
  SE: 'Europe/Stockholm',
  DK: 'Europe/Copenhagen',
  FI: 'Europe/Helsinki',
};

/** Default timezone for a market, derived from its first country. */
export function defaultTimezoneForCountries(countries: string[]): string {
  for (const country of countries) {
    const timezone = COUNTRY_TIMEZONES[country.toUpperCase()];
    if (timezone) {
      return timezone;
    }
  }
  return TIMEZONE_OPTIONS[0].value;
}
